import React, { createContext, useContext } from 'react';

export type Plan = 'free' | 'pro' | 'enterprise' | 'family' | 'student';

export type SubscriptionData = {
  plan: Plan;
  region?: string;
  isPremium: boolean;
  features?: string[];
  limits?: {
    projects?: number;
    storage?: string;
    teamMembers?: number;
  };
};

const defaultSubscription: SubscriptionData = {
  plan: 'free',
  isPremium: false,
  region: 'US',
  features: ['basic_tasks', 'basic_calendar'],
  limits: {
    projects: 3,
    storage: '500MB',
    teamMembers: 1,
  },
};

const Ctx = createContext<SubscriptionData>(defaultSubscription);

export const SubscriptionProvider: React.FC<{
  value?: Partial<SubscriptionData>;
  children: React.ReactNode;
}> = ({ value = {}, children }) => {
  const fullValue = { ...defaultSubscription, ...value };
  return <Ctx.Provider value={fullValue}>{children}</Ctx.Provider>;
};

export const useSubscription = () => useContext(Ctx);

// Feature gate helper
export const useFeatureGate = (feature: string) => {
  const subscription = useSubscription();
  return subscription.features?.includes(feature) || subscription.isPremium;
};
